import { exists } from '@/api'

export interface SynonymGroup {
  id: number
  group: number
  data: string[]
  revision: number
}

export const defaultSynonymGroup = (): SynonymGroup => ({
  id: 0,
  group: 0,
  data: [],
  revision: 0
})

export function SynonymGroupFromJSON(json: any): SynonymGroup {
  return {
    id: exists(json, 'id') ? json.id : 0,
    group: exists(json, 'group') ? json.group : 0,
    data: exists(json, 'data') ? json.data : [],
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
